import {monitoringTableSort} from '../monitoring-products-tool.js';
import '@opportunus-lib-js/lazy-load/amp-lazy-leaflets.js';
import { initGridSort } from "@opportunus-lib-js/grid/grid-sort.js";

//lazyBranchInit();
//lazyBranchReinit();
monitoringTableSort()
initGridSort();

const showMoreButton = document.getElementsByClassName('store-filter-more-button')[0];
const moreStores = document.getElementsByClassName('store-filter-more')[0];

if (typeof showMoreButton !== 'undefined') {
// zobrazení více obchodů na straně produktu
    showMoreButton.addEventListener('click', function () {
        // skryjeme tlačítko
        showMoreButton.style.display = 'none';

        // inline je defaultní hodnota
        moreStores.style.display = 'inline';
    });
}
let filterButton = document.getElementsByClassName("filter btn btn-default");
if(filterButton.length > 0)
{
    filterButton = filterButton[0];
    filterButton.addEventListener('click', event =>
        {
            let url = filterButton.getAttribute('data-location');

            if (typeof moreStores === 'undefined' || !moreStores.getAttribute('data-amp'))
            {
                window.location.replace(url);
            }
        });
}


document.querySelectorAll('.store-checkbox').forEach(item => {

    item.addEventListener('click', event =>
    {
        let checked = item.checked;

        item.parentNode.querySelectorAll('.check-entity-text').forEach(item =>
        {
            if(item.getAttribute('class').lastIndexOf('active') > -1)
            {
                item.setAttribute("class", "check-entity-text");
            }
            else
            {
                item.setAttribute("class", "check-entity-text active");
            }
        });
        prepareFilter();
    });
})

function prepareFilter()
{
    let stores = [];
    let storeFilter = document.getElementsByClassName('store-filter')[0];
    let checked = storeFilter.getElementsByClassName('active');
    let button = storeFilter.getElementsByClassName('filter btn btn-default');

    for(let i = 0; i < checked.length; i++)
    {
        let item = checked[i];
        let container = item.parentNode;

        let input = container.getElementsByClassName('store-checkbox')

        if(input.length > 0)
        {
            input = input[0];
            stores.push(input.getAttribute('data-name'));
        }
    }

    if(button.length > 0)
    {
        button = button[0];
        let baseUrl = button.getAttribute('data-navigate');
        let baseUrlBlock = button.getAttribute('data-navigate-block-robots');

        if(stores.length > 0)
        {
            // Víc než jeden obchod = blok pro boty
            if(stores.length > 1)
            {
                baseUrl = baseUrlBlock;
            }

            baseUrl = baseUrl + '?store=' + stores.join();
        }
        button.setAttribute('data-location', baseUrl);
        button.setAttribute('on', "tap:AMP.navigateTo(url='"+ baseUrl + "')");
    }
}